module.exports = __webpack_public_path__ + "img/vegetable-pea-shoots-350x184.e0594cb0.jpg";